import { t } from "i18next";
import React from "react";
import { ReactComponent as PemBoyCheck } from "../rsc/pemboy_checkin.svg";
import { ReactComponent as PemBoyClock } from "../rsc/pemboy_clock.svg";


type Props = {
    type: 'clock' | 'check'
    isVisible: boolean,
    subtitle?: string
    title: string
}

export function EmptyView({ type, isVisible = false, title, subtitle }: Props) {


    const getImg = () => {
        switch (type) {
            case 'clock': return <PemBoyClock/>
            case 'check': return <PemBoyCheck/>
            default: return <PemBoyCheck/>
        }
    } 

    return (
        <div hidden={!isVisible}>
            <div className="pempem-flex-row-center lightGreyBgColor" style={{ width: 'fit-content', padding: '32px 24px', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                <div className="pempem-flex-col">
                    <div className="font-32 bold" style={{ marginBottom: 8, color: '#888' }}>{title}</div>
                    <div className="font-normal" style={{ color: '#aaa' }}>{subtitle ?? t('check_back_later')} </div>
                </div>
                {getImg()}
            </div>
        </div>
    )
}